/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import './m.css';
import ScrollAnimation from 'react-animate-on-scroll';

export default function Brief() {
    return (
        <>
            <div className="min-vh-100 text-center m-0 d-flex flex-column justify-content-center">
                <ScrollAnimation animateIn='fadeInDown'>
                    <div className="what-i-do">
                        BREIF
                </div>
                </ScrollAnimation>

                <div className="container">
                    <ScrollAnimation animateIn='fadeIn'>
                        <div className="container what-i-do-text">
                            <a>  I specialize in digital strategy, project management, and development. I have been at this design game for a good three   years, and have sharpened my skills working on over 5 projects.</a><br /><a>With every project, I implement the highest standards of communication and collaboration, and believe that process is the foundation of success.</a>
                        </div>
                    </ScrollAnimation>
                </div>
            </div>
        </>
    )
}
